import React from 'react';

//TODO: Get this from config object
const PRESET_300 = {
  name: 'preset_300',
  width: '300w',
};
const PRESET_400 = {
  name: 'preset_400',
  width: '400w',
};
const PRESET_500 = {
  name: 'preset_500',
  width: '500w',
};
const PRESET_600 = {
  name: 'preset_600',
  width: '600w',
};
const PRESET_700 = {
  name: 'preset_700',
  width: '700w',
};
const PRESET_800 = {
  name: 'preset_800',
  width: '800w',
};
const PRESET_1000 = {
  name: 'preset_1000',
  width: '1000w',
};
const PRESET_1200 = {
  name: 'preset_1200',
  width: '1200w',
};
const PRESET_1500 = {
  name: 'preset_1500',
  width: '1500w',
};
const PRESET_1800 = {
  name: 'preset_1800',
  width: '1800w',
};
const PRESET_2000 = {
  name: 'preset_2000',
  width: '2000w',
};
const PRESET_2200 = {
  name: 'preset_2200',
  width: '2200w',
};
const PRESET_2500 = {
  name: 'preset_2500',
  width: '2500w',
};

export default (WrappedComponent) => {
  const SrcSets = (props) => {
    const imgIsTouched = () => {
      return props.ImageUrl && props.ImageUrl.indexOf('?') > 0;
    };

    const defaultPreset = () => {
      if (!props.DefaultPreset) return props.ImageUrl;
      const paramOrQuery = imgIsTouched() ? '&' : '?';
      return `${props.ImageUrl}${paramOrQuery}preset=${props.DefaultPreset.name}`;
    };

    const paramOrQuery = imgIsTouched() ? '&' : '?';

    const srcSets =
      props.isViewed !== false
        ? `${props.ImageUrl}${paramOrQuery}preset=${PRESET_300.name} ${PRESET_300.width},
       ${props.ImageUrl}${paramOrQuery}preset=${PRESET_400.name} ${PRESET_400.width},
       ${props.ImageUrl}${paramOrQuery}preset=${PRESET_500.name} ${PRESET_500.width},
       ${props.ImageUrl}${paramOrQuery}preset=${PRESET_600.name} ${PRESET_600.width},
       ${props.ImageUrl}${paramOrQuery}preset=${PRESET_700.name} ${PRESET_700.width},
       ${props.ImageUrl}${paramOrQuery}preset=${PRESET_800.name} ${PRESET_800.width},
       ${props.ImageUrl}${paramOrQuery}preset=${PRESET_1000.name} ${PRESET_1000.width},
       ${props.ImageUrl}${paramOrQuery}preset=${PRESET_1200.name} ${PRESET_1200.width},
       ${props.ImageUrl}${paramOrQuery}preset=${PRESET_1500.name} ${PRESET_1500.width},
       ${props.ImageUrl}${paramOrQuery}preset=${PRESET_1800.name} ${PRESET_1800.width},
       ${props.ImageUrl}${paramOrQuery}preset=${PRESET_2000.name} ${PRESET_2000.width},
       ${props.ImageUrl}${paramOrQuery}preset=${PRESET_2200.name} ${PRESET_2200.width},
       ${props.ImageUrl}${paramOrQuery}preset=${PRESET_2500.name} ${PRESET_2500.width}`
        : null;

    return (
      <WrappedComponent
        {...props}
        isSrcSets={true}
        SrcSets={{
          srcSet: srcSets,
        }}
        ImageUrl={defaultPreset()}
      />
    );
  };

  return SrcSets;
};
